// Top level libraries and 3rd party dependencies
import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { Redirect } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

import {
    getConversationDetails,
    limitedLogin,
    startLimitedLoginMessageTimer,
} from '../../actions/session/sessionActions';
import { limitedLoginSendMessage } from '../../actions/messages/messagesActions';

import { LIMITED_LOGIN_SEND_MESSAGE_TIMER } from '../../constants/ActionTypes';
import { LIMITED_LOGIN_SEND_MESSAGE_TIMER_LENGTH } from '../../constants/AppConstants';
import Expired from './Expired';


class ExpiredContainer extends Component {
    static propTypes = {
        conversationDetails: object.isRequired,
        getConversationDetails: func.isRequired,
        history: object,
        limitedLogin: func.isRequired,
        loadingState: object,
        location: object,
        match: object,
        messages: object,
        session: object,
        startLimitedLoginMessageTimer: func.isRequired,
    };

    // Patient auth success with their PIN, start the browser-level timer
    componentDidUpdate(prevProps) {
        if (prevProps.session.limitedLogin !== this.props.session.limitedLogin) {

            const payload = {
                actionName: LIMITED_LOGIN_SEND_MESSAGE_TIMER,
                timerName: LIMITED_LOGIN_SEND_MESSAGE_TIMER,
                timerPeriod: LIMITED_LOGIN_SEND_MESSAGE_TIMER_LENGTH,
            };
            this.props.startLimitedLoginMessageTimer(payload);

        }
    }

    componentDidMount() {
        this.updateConversationDetails();
    }

    updateConversationDetails = () => {
        const { conversationHash } = this.props.match.params;

        if (conversationHash) {
            this.props.getConversationDetails(conversationHash);
        }
    };

    render() {
        const { conversationHash } = this.props.match.params;
        const {
            loadingState,
            messages,
            conversationDetails,
            session,
            limitedLogin,
            limitedLoginSendMessage,
        } = this.props;

        // If we have confirmed a PIN and this is an expired conversation, render the Expired "login" UI.
        return (
            conversationDetails.hasConfirmedPIN && conversationDetails.expiredConversation ?
                <Expired
                    conversationHash={conversationHash}
                    loadingState={loadingState}
                    limitedLogin={limitedLogin}
                    limitedLoginSendMessage={limitedLoginSendMessage}
                    messages={messages}
                    conversationDetails={conversationDetails}
                    session={session}
                /> :
                <Redirect to={`/verify/${conversationHash}`}/>
        );
    }
}

const mapStateToProps = state => ({
    loadingState: state.loadingState,
    messages: state.messages,
    conversationDetails: state.session.conversationDetails,
    session: state.session,
});

const mapDispatchToProps = dispatch => ({
    getConversationDetails: conversationId => dispatch(getConversationDetails(conversationId)),
    limitedLogin: request => dispatch(limitedLogin(request)),
    limitedLoginSendMessage: request => dispatch(limitedLoginSendMessage(request)),
    startLimitedLoginMessageTimer: request => dispatch(startLimitedLoginMessageTimer(request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredContainer);
